
export default {
  name: 'SvgIcon',
  components: {
    IconFacebook: () => import(/* webpackChunkName: "IconFacebook" */ './IconFacebook'),
    IconTwitter: () => import(/* webpackChunkName: "IconTwitter" */ './IconTwitter'),
    IconInstagram: () => import(/* webpackChunkName: "IconInstagram" */ './IconInstagram'),
    IconLinkedIn: () => import(/* webpackChunkName: "IconLinkedIn" */ './IconLinkedIn'),
    IconGlobe: () => import(/* webpackChunkName: "IconGlobe" */ './IconGlobe'),
    IconImageLinear: () => import(/* webpackChunkName: "IconImageLinear" */ './IconImageLinear'),
    IconBadgeLinear: () => import(/* webpackChunkName: "IconBadgeLinear" */ './IconBadgeLinear'),
    IconFirewallLinear: () => import(/* webpackChunkName: "IconFirewallLinear" */ './IconFirewallLinear'),
    IconFolder: () => import(/* webpackChunkName: "IconFolder" */ './IconFolder'),
    IconGoogleDrive: () => import(/* webpackChunkName: "IconGoogleDrive" */ './IconGoogleDrive'),
    IconDropbox: () => import(/* webpackChunkName: "IconDropbox" */ './IconDropbox'),
    IconOnedrive: () => import(/* webpackChunkName: "IconDropbox" */ './IconOnedrive'),
    IconLink: () => import(/* webpackChunkName: "IconLink" */ './IconLink'),
    IconQRCode: () => import(/* webpackChunkName: "IconQRCode" */ './IconQRCode'),
    IconDiamond: () => import(/* webpackChunkName: "IconDiamond" */ './IconDiamond')
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    fill: {
      default: '#000000'
    },
    // eslint-disable-next-line vue/require-prop-types
    activeFill: {
      default: '#393838'
    },
    name: {
      default: '',
      required: true,
      validator: function (value) {
        return [
          'facebook',
          'twitter',
          'instagram',
          'linkedin',
          'globe',
          'arrow_up_linear',
          'arrow_down_linear',
          'image_linear',
          'badge_linear',
          'firewall_linear',
          'folder',
          'google_drive',
          'dropbox',
          'link',
          'qr',
          'diamond',
          'onedrive'
        ].includes(value)
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    height: {
      default: '20'
    },
    // eslint-disable-next-line vue/require-prop-types
    width: {
      default: '20'
    }
  },
  data: () => ({ active: false }),
  computed: {
    componentName () {
      const names = {
        facebook: 'IconFacebook',
        twitter: 'IconTwitter',
        instagram: 'IconInstagram',
        linkedin: 'IconLinkedIn',
        globe: 'IconGlobe',
        image_linear: 'IconImageLinear',
        badge_linear: 'IconBadgeLinear',
        firewall_linear: 'IconFirewallLinear',
        folder: 'IconFolder',
        google_drive: 'IconGoogleDrive',
        dropbox: 'IconDropbox',
        onedrive: 'IconOnedrive',
        link: 'IconLink',
        qr: 'IconQRCode',
        diamond: 'IconDiamond'
      }
      return names[this.name]
    },
    iconFill () {
      return this.active ? this.activeFill : this.fill
    }
  }
}
